export default "__VITE_ASSET__Dg8G_UQc__"